import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { IFaq } from '@propertypal/shared/src/types/strapi';
import { ReadingTime } from '@propertypal/shared/src/utils/faq/getReadingTime';
import dayjs from 'dayjs';
import React from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Heading } from '../typography';
import { BackToTop, FaqArticleDetail, FaqArticleDetails, FaqRichText, FaqTag, FaqTags } from './Faq.style';
import FaqForm from './FaqForm';
import FaqNotFound from './FaqNotFound';

interface FaqArticleProps {
  data: IFaq | null;
  readingTime: ReadingTime;
}

const FaqArticle: React.FC<FaqArticleProps> = ({ data, readingTime }) => {
  return (
    <div>
      {data && data.attributes != null && <Heading data-testid="faq-heading">{data?.attributes.question}</Heading>}
      <FaqArticleDetails>
        {data?.attributes.updatedAt && (
          <FaqArticleDetail data-testid="faq-last-updated">
            <FontAwesomeIcon icon={faCalendar} />
            <span>Last Updated {dayjs(data.attributes.updatedAt).format('D MMM YYYY')}</span>
          </FaqArticleDetail>
        )}
        {data?.attributes?.content && (
          <FaqArticleDetail data-testid="faq-reading-time">
            <FontAwesomeIcon icon={faClock} />
            <span>{readingTime}</span>
          </FaqArticleDetail>
        )}
      </FaqArticleDetails>
      {data && data?.attributes?.tags && data?.attributes?.tags?.length > 0 && (
        <FaqTags data-testid="faq-tags">
          {data?.attributes?.tags.map((tag) => (
            <FaqTag data-testid="faq-tag" key={tag.id}>
              {tag.name}
            </FaqTag>
          ))}
        </FaqTags>
      )}
      {data && data.attributes != null ? <FaqRichText html={data.attributes.content} /> : <FaqNotFound />}
      {data &&
        data.attributes.form &&
        (data.attributes.form === 'agentForm' || data.attributes.form === 'publicForm') && (
          <FaqForm type={data.attributes.form} query={data?.attributes.question} />
        )}
      <BackToTop
        data-testid="faq-back-to-top"
        onClick={() => document.getElementById('faq-container')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <FontAwesomeIcon icon={faChevronUp} size={12} />
        <span>back to top</span>
      </BackToTop>
    </div>
  );
};

export default FaqArticle;
